import {BaseDTO} from "../_baseDTO.interface";

export interface ValuationQuoteDataDTO extends BaseDTO {

  valuationQuoteId: string;
  resultData: string;
}
